import { render, staticRenderFns } from "./WorldViewFolderList.vue?vue&type=template&id=48abc46c&scoped=true"
import script from "./WorldViewFolderList.vue?vue&type=script&lang=ts"
export * from "./WorldViewFolderList.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewFolderList.vue?vue&type=style&index=0&id=48abc46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48abc46c",
  null
  
)

export default component.exports